import { EntityScreenState } from './reducer'

export const getEntityScreenRows = (state: { entityScreen: EntityScreenState }) =>
  state.entityScreen.rows

export const getEntityScreenLoader = (state: { entityScreen: EntityScreenState }) =>
  state.entityScreen.isLoading

export const isEntityScreenStale = (state: { entityScreen: EntityScreenState }) =>
  state.entityScreen.stale
